import NotificationService from "../../Services/Api/NotificationService";

export const state = {
    notifications: [],
}

export const mutations = {
    ADD_NOTIFICATION(state, newValue) {
        if (state.notifications.length >= 5) {
            state.notifications.splice(-1)
        }
        state.notifications.unshift(newValue)
    },
    CLEAR_NOTIFICATIONS(state) {
        state.notifications = []
    },
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },
}

export const getters = {
    notifications(state) {
        return state.notifications
    },
    unreadNotifications(state) {
        return state.unreadNotifications
    }
}

export const actions = {
    addNotification({commit}, {notification}) {
        commit('ADD_NOTIFICATION', notification)
    },
    async clearNotifications({commit}) {
        await NotificationService.markAsRead().then(() => {
            commit('CLEAR_NOTIFICATIONS')
        })
    },
    async getNotifications({commit}) {
        await NotificationService.all({query: `paginate=5&page=1&unread=true`}).then((res) => {
            commit('SET_NOTIFICATIONS', res.data.data)
        })
    }
}

